<div [attr.section-name]="sectionName"
     appIntersectionObserver
     (visibilityChange)="onVisibilityChanged($event)">
  <h3>Opening Hours</h3>

  <section>
    <app-editable-textual-input [fieldId]="'mondayHours'"
                                [iconName]="'watch_later_outline'"
                                [isFieldWithDataSource]="isFieldWithDataSource('mondayHours')"
                                [hasActiveConnection]="hasActiveConnection('mondayHours') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'tuesdayHours'"
                                [isFieldWithDataSource]="isFieldWithDataSource('tuesdayHours')"
                                [hasActiveConnection]="hasActiveConnection('tuesdayHours') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'wednesdayHours'"
                                [isFieldWithDataSource]="isFieldWithDataSource('wednesdayHours')"
                                [hasActiveConnection]="hasActiveConnection('wednesdayHours') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'thursdayHours'"
                                [isFieldWithDataSource]="isFieldWithDataSource('thursdayHours')"
                                [hasActiveConnection]="hasActiveConnection('thursdayHours') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'fridayHours'"
                                [isFieldWithDataSource]="isFieldWithDataSource('fridayHours')"
                                [hasActiveConnection]="hasActiveConnection('fridayHours') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'saturdayHours'"
                                [isFieldWithDataSource]="isFieldWithDataSource('saturdayHours')"
                                [hasActiveConnection]="hasActiveConnection('saturdayHours') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'sundayHours'"
                                [isFieldWithDataSource]="isFieldWithDataSource('sundayHours')"
                                [hasActiveConnection]="hasActiveConnection('sundayHours') | ngrxPush"
    ></app-editable-textual-input>

    <!-- TODO check if value needs to be split - analogously to boolean col compo 'special_hours'   -->
    <app-editable-textual-input [subtype]="'multiline_text'"
                                [fieldId]="'specialHours'"
                                [iconName]="'event'"
                                [isFieldWithDataSource]="isFieldWithDataSource('specialHours')"
                                [hasActiveConnection]="hasActiveConnection('specialHours') | ngrxPush"
    ></app-editable-textual-input>

    <!-- TODO check if value needs to be split - analogously to boolean col compo 'gx_special_hours'   -->
    <app-editable-textual-input [subtype]="'multiline_text'"
                                [fieldId]="'gxSpecialHours'"
                                [isFieldWithDataSource]="isFieldWithDataSource('gxSpecialHours')"
                                [hasActiveConnection]="hasActiveConnection('gxSpecialHours') | ngrxPush"
    ></app-editable-textual-input>

    <!-- TODO decide if to use datepicker -->
    <app-editable-textual-input [fieldId]="'openingDate'"
                                [iconName]="'event'"
                                [isFieldWithDataSource]="isFieldWithDataSource('openingDate')"
                                [hasActiveConnection]="hasActiveConnection('openingDate') | ngrxPush"
    ></app-editable-textual-input>

  </section>
</div>